import React from "react";
import { ArrowRight, Loader2, Lock } from "lucide-react";
import CustomInput from "../../Common/CustomInput";

const LoginForm = ({ setOpenSignUp, handleInputChange, handleSubmit, error, isLoading }) => {
  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSubmit();
  };

  return (
    <div className="rounded-3xl border border-slate-200 bg-white/90 p-7 shadow-soft backdrop-blur sm:p-9">
      <h2 className="text-2xl font-extrabold tracking-tight sm:text-3xl">Sign in</h2>
      <p className="mt-2 text-sm text-slate-600">
        Enter your email or mobile number and we'll send you a one-time code. No password needed.
      </p>

      <div className="mt-7 space-y-5">
        <CustomInput
          label="Email or mobile number"
          type="text"
          autoFocus
          autoComplete="username"
          onChange={(e) => handleInputChange(e)}
          placeholder="Enter your Email or Mobile Number"
          error={error}
          onKeyDown={handleKeyDown}
        />
        <button onClick={handleSubmit} disabled={isLoading} className="hf-btn py-3.5 text-base">
          {isLoading ? (
            <>
              <Loader2 className="h-5 w-5 animate-spin" /> Sending code…
            </>
          ) : (
            <>
              Continue <ArrowRight className="h-5 w-5" />
            </>
          )}
        </button>
      </div>

      <div className="mt-6 flex items-center gap-2 rounded-xl bg-slate-50 px-4 py-3 text-xs text-slate-600">
        <Lock className="h-4 w-4 flex-shrink-0 text-brand-600" />
        Works for patients, doctors, hospital staff and administrators.
      </div>

      <p className="mt-6 text-center text-sm text-slate-600">
        Don't have an account?{" "}
        <button type="button" className="hf-link" onClick={() => setOpenSignUp(true)}>
          Sign up
        </button>
      </p>
    </div>
  );
};

export default LoginForm;
